import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Session token: after a PIN login the session-login Edge Function returns a
// signed token that identifies the employee to the database (Phase 2 - see
// supabase/migrations/session_token_prep.sql). When one is stored, every
// request to Supabase carries it instead of the bare public key; without one
// (flag off, or expired) requests go out exactly as before.
export const SESSION_TOKEN_KEY = 'crm_session_token';

const readSessionToken = () => {
  try {
    const raw = localStorage.getItem(SESSION_TOKEN_KEY);
    if (!raw) return null;
    const { token, exp } = JSON.parse(raw);
    // Treat a token with under a minute left as already expired.
    if (!token || !exp || exp * 1000 < Date.now() + 60 * 1000) return null;
    return token;
  } catch (err) {
    return null;
  }
};

const fetchWithSession = (input, init) => {
  const token = readSessionToken();
  const target = typeof input === 'string' ? input : input?.url;
  if (!token || !target || !target.startsWith(supabaseUrl)) return fetch(input, init);
  const headers = new Headers(init?.headers || (typeof input === 'string' ? undefined : input.headers));
  headers.set('Authorization', `Bearer ${token}`);
  return fetch(input, { ...init, headers });
};

export const supabase = createClient(supabaseUrl, supabaseKey, { global: { fetch: fetchWithSession } });

export const getSessionToken = readSessionToken;

export const storeSessionToken = (token, exp) => {
  localStorage.setItem(SESSION_TOKEN_KEY, JSON.stringify({ token, exp }));
  supabase.realtime.setAuth(token);
};

export const clearSessionToken = () => {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  supabase.realtime.setAuth(supabaseKey);
};
